module.exports = __webpack_public_path__ + "static/media/users-inactive.73b459cc.svg";